/**
 * Utility functions for debugging Firebase Storage access
 */

// Log detailed information about a storage reference
export const logStorageRefDetails = (storageRef) => {
  console.log("Storage Reference Details:");
  console.log("- Bucket:", storageRef.bucket);
  console.log("- Full Path:", storageRef.fullPath);
  console.log("- Name:", storageRef.name);
  console.log("- Parent:", storageRef.parent);
  console.log("- Root:", storageRef.root);
  console.log("- Storage:", storageRef.storage);
};

// Log Firebase app configuration (without sensitive data)
export const logFirebaseConfig = (app) => {
  const config = app.options;
  console.log("Firebase App Configuration:");
  console.log("- App Name:", app.name);
  console.log("- Project ID:", config.projectId);
  console.log("- Storage Bucket:", config.storageBucket);
  console.log("- Auth Domain:", config.authDomain);
  // Don't log API keys or other sensitive information
};

// Log authentication state
export const logAuthState = (auth) => {
  console.log("Authentication State:");
  console.log(
    "- Current User:",
    auth.currentUser ? "Signed In" : "Not Signed In"
  );
  if (auth.currentUser) {
    console.log("- User ID:", auth.currentUser.uid);
    console.log("- Email:", auth.currentUser.email);
    console.log("- Provider ID:", auth.currentUser.providerId);
  }
};
